import { render, staticRenderFns } from "./DevInfoCard.vue?vue&type=template&id=f4e091be&scoped=true"
import script from "./DevInfoCard.vue?vue&type=script&lang=js"
export * from "./DevInfoCard.vue?vue&type=script&lang=js"
import style0 from "./DevInfoCard.vue?vue&type=style&index=0&id=f4e091be&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e091be",
  null
  
)

export default component.exports